import lazyLoading from './lazyLoading'

export default {
  path: '/projects/business',
  system: 'business_sites',
  component: lazyLoading('projects', true),
  meta: {
    label: 'Projects',
    expanded: false,
    icon: 'folder',
    auth: true
  },
  children: [{
    path: '/projects/business',
    name: 'BusinessProjects',
    hidden: true,
    meta: {
      label: '',
    },
    component: lazyLoading('businessProjects/ProjectListWrapper'),
  }, {
    name: 'EditBusinessProject',
    path: '/projects/business/:id/edit',
    hidden: true,
    meta: {
      label: '',
    },
    component: lazyLoading('businessProjects/Edit', true),
    props: true
  }, {
    name: 'EditBusinessSite',
    path: '/projects/business/:id/edit/:site_id',
    hidden: true,
    meta: {
      label: '',
    },
    component: lazyLoading('businessProjects/EditContent'),
    props: true
  }, {
    name: 'NewBusinessProject',
    path: '/projects/business/new',
    hidden: true,
    meta: {
      label: '',
      link: 'projects/business/new'
    },
    component: lazyLoading('businessProjects/create', true),
    props: route => ({ newRegister: route.query.newRegister && JSON.parse(route.query.newRegister) })
  }, {
    name: 'BusinessProjectOptimization',
    path: '/projects/business/optimize',
    hidden: true,
    meta: {
      label: '',
      link: 'projects/business/optimize'
    },
    component: lazyLoading('businessProjects/optimize', true)
  }
  ]
}
